<div
  class="container flex flex-row lt-md:flex-col justify-between items-start lt-md:justify-start lt-md:items-center"
>
  <div
    class="flex flex-col gap-[20px] justify-start items-start lt-md:order-2 flex-[100%] max-w-[50%] lt-md:flex-1"
  >
    <h2>
      {{
        '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.NO_PERMISSION.TITLE'
          | translate
      }}
    </h2>
    <vi-text>
      {{
        '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.NO_PERMISSION.DESCRIPTION'
          | translate
      }}
    </vi-text>
  </div>
  <img class="lt-md:order-1" src="./assets/img/diagnostic_installer_guy.svg" />
</div>
